import React, { useCallback } from 'react';
import { Box, BoxExtendedProps, Option, OutlinedCompleteIcon, RawButton, Text } from '@common-fe/common-fe';

interface Props extends BoxExtendedProps {
  testId?: string;
  title?: string;
  value?: string;
  additionalValue?: Option['additionalValue'];
  metadata?: Record<string, string>;
  isActive?: boolean;
  node?: React.ReactNode;
  gridColumn?: string;
  maxItemWidth?: string;
  onChangeValue?: (value: string) => void;
  onCreateValue?: (value: Record<string, string>) => void;
}

const FieldSetupOption: React.FC<Props> = ({
  testId,
  title,
  value,
  additionalValue,
  metadata,
  isActive,
  node,
  gridColumn,
  maxItemWidth,
  onChangeValue,
  onCreateValue
}) => {
  const handleChange = useCallback(() => {
    if (value) {
      onChangeValue?.(value);
    } else if (metadata) {
      onCreateValue?.(metadata);
    }
  }, [onChangeValue, onCreateValue, value, metadata]);

  return (
    <Box style={gridColumn ? { gridColumn } : undefined}>
      <RawButton
        data-testId={`${testId}-field-setup-option`}
        style={{ width: maxItemWidth }}
        onClick={handleChange}
      >
        <Box
          {...isActive ? { background: 'successContainer' } : {}}
          border={{size: 'small', color: isActive ? 'success' : value ? 'border1' : 'missingBorder' }}
          pad={{ horizontal: 'spacing16', vertical: '10px' }}
          round="button1Round"
          direction="row"
          align="center"
          justify="center"
        >
          <Box align="center" justify="center">
            <Text
              textAlign="center"
              color={isActive ? 'success' : value ? 'textBody' : 'missingDetail'}
              weight={isActive ? 700 : 400}
            >
              {title}
            </Text>
            {additionalValue ? (
              <Text textAlign="center" color="textSecondary" weight={400}>
                {additionalValue as string}
              </Text>
            ) : null}
          </Box>
          {isActive ? (
            <Box margin={{ left: 'spacing2' }}>
              <OutlinedCompleteIcon color="success" size="16px" />
            </Box>
          ) : null}
        </Box>
      </RawButton>
      {node}
    </Box>
  );
};

export default FieldSetupOption;
